$(document).ready(function () {
  function createSnowflake() {
    const snowflake = $('<div class="snowflake">☁</div>');

    const startTop = Math.random() * $(window).height();   // random vertical start
    const endTop = startTop + (Math.random() * 100 - 50);  // slight vertical movement
    const duration = 10000 + Math.random() * 10000;        // 10 to 20 sec (slower)
    const size = 10 + Math.random() * 20;

    snowflake.css({
      top: startTop,
      fontSize: size + 'px',
      left: '100%'        // Start from right
    });

    $('body').append(snowflake);

    snowflake.animate({
      left: '-50px',       // Move fully to left
      top: endTop + 'px',
      opacity: 0.2
    }, duration, 'linear', function () {
      $(this).remove();
    });
  }

  // Cloud frequency (agar ye bhi slow chahiye toh bata dena)
  setInterval(createSnowflake, 300);
});
